import React, {useEffect, useState} from "react";
import {FormattedMessage} from "react-intl";
import {
    Facebook,
    Headphones,
    Instagram,
    Link2,
    Mail,
    MapPin,
    PhoneCall,
    Share2,
    Shield,
    Twitter,
    Phone
} from "react-feather";
import {Close, Telegram, WhatsApp} from "@material-ui/icons";
import {Col, NavLink, Row} from "reactstrap";
import {PhoneAndroid, Pinterest, YouTube} from "@material-ui/icons";
import {history} from "../../../history";
import {connect, useSelector} from "react-redux";
import logo from "../../../assets/images/logo/light-logo.png"
import {BsPhone} from "react-icons/bs";
import {AiOutlinePhone} from "react-icons/ai";
import {useNavigate} from "react-router-dom";
import {DETAILS} from "../../../assets/data/config/storeConfig";
import AOS from "aos";

const Footer = (props)=>{

    const UI = useSelector(state => state.UI);
    const [service , setService] = useState([])
    const navigate = useNavigate()

    useEffect(() => {
        if (UI.servicesCategory)
            setService(UI.servicesCategory)
    }, [UI])
     const renderSocialIcons = (item) => {
        let n = item.link.lastIndexOf('/');
        let mediaId = item.link.substring(n + 1);
        switch (item.media) {
            case "instagram":
                return (// <div className= "social-icon">
                    <Col className="d-flex align-items-center justify-content-center">
                        <div>
                            <a href={item.link} target="_blank" title={mediaId}>
                                <i className="lab la-instagram icon-whatsapp"></i>
                            </a>
                        </div>
                    </Col>)
            case "telegram":
                return (// <div className="social-icon">
                    <Col className="d-flex align-items-center justify-content-center">
                        <div>
                            <a href={item.link} target="_blank" title={mediaId}>
                                <i className="lab la-telegram-plane icon-whatsapp"></i>
                            </a>
                        </div>
                    </Col>)
            case "whatsApp":
                return (// <div className="social-icon">
                    <Col className="d-flex align-items-center justify-content-center">
                        <div>
                            <a href={item.link} target="_blank" title={mediaId}>
                                <i className="lab la-whatsapp icon-whatsapp"></i>
                            </a>
                        </div>
                    </Col>)

            case "aparat":
                return <a href={item.link} target="_blank"
                          title={mediaId}>
                    {/*<img src={aparat} alt="aparat" width="26px"/>*/}
                </a>
            case "tiktok":
                return <a href={item.link} target="_blank"
                          title={mediaId}>
                    {/*<img src={tiktok} alt="tiktok" width="26px"/>*/}
                </a>
            case "vimeo":
                return <a href={item.link} target="_blank"
                          title={mediaId}>
                    {/*<img src={vimeo} alt="vimeo" width="26px"/>*/}
                </a>
            case "pinterest":
                return (
                    <Col sm={6} md={4} lg={12} className="d-flex justify-content-center col">
                        <div>
                            <a href={item.link} target="_blank" title={mediaId}>
                                <i className="lab la-pinterest icon-whatsapp"></i>
                            </a>
                        </div>
                    </Col>)
            case "youtube":
                return (
                    <Col sm={6} md={4} lg={6} className="d-flex justify-content-center col">
                        <div>
                            <a href={item.link} target="_blank" title={mediaId}>
                                <i className="lab la-youtube icon-whatsapp"></i>
                            </a>
                        </div>
                    </Col>)
            case "twitter":
                return <a href={item.link} target="_blank" title={mediaId}>
                    <Twitter className="icon-twitter"/>
                </a>
            case "faceBook":
                return <a href={item.link} target="_blank" title={mediaId}>
                    <Facebook className="icon-facebook"/>
                </a>
            default:
                return null
        }
    }
    const handleSupport = (targetPath) => {
        if (targetPath) history.push(targetPath)
        this.setState({
            support: !this.state.support,
        })
    }
    return(
        <>
            <div className='web-footer mt-5'>
                {/*{data.ZarinpalLink &&*/}
                {/*    <div id="zarinpal" className="trust d-flex px-0 py-1">*/}

                {/*    </div>*/}
                {/*}*/}
                <Row className=' mx-auto py-2  container-custom'>
                    <Col sm={12} md={6} lg={4} className='about-shop-footer '>
                        <div className='d-flex align-items-center justify-content-start'>
                            <h3 className='my-2 my-md-0 my-lg-0'>
                                <img src={logo} width={50} className='mr-1'/>
                                شرکت حسابداری فریور حساب
                            </h3>
                        </div>
                        <div className='mt-1'>
                            <p className='text-justify line-height-2'>
                                مجموعه ما متشکل از یک تیم حرفه ای با سابقه فعالیت حسابداری و حسابرسی در بهترین
                                مجموعه ها ،سازمان ها و شرکت های تولیدی ، بازرگانی ، خدماتی و بورسی و مطابق با اخرین
                                استاندارد های حسابداری ، حسابرسی، قوانین مالیاتی و قانون تجارت آماده خدمت رسانی به
                                شما عزیزان در تمامی زمینه های خدمات مالی و حسابداری ، خدمات حسابرسی و کنترل های
                                داخلی ، خدمات مالیاتی ، خدمات اداری و پرسنلی و خدمات مدیریتی به صورت کامل و همه
                                جانبه با تضمین کیفیت و پشتیبانی و با بهترین تعرفه می باشد .
                            </p>
                            <div className='social-media d-flex justify-content-md-start justify-content-center'>
                                <div className='d-flex align-items-center justify-content-around rounded'>
                                    <a href='https://instagram.com/farivar_hesab'><Instagram
                                        size={'35px'}/></a>
                                    <a href="https://api.whatsapp.com/send/?phone=989372639959&text&app_absent=0"><WhatsApp/></a>
                                    <a href="https://t.me/+989372639959"><Telegram/></a>
                                    <a href="mailto:info@farivarhesab.com"><Mail size={'35px'}/></a>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col sm={12} md={6} lg={2} className='QuickLink-footer pl-0 pl-md-1'>
                        <h3 className='text-center'>لینک دسترسی سریع</h3>
                        <div className="pages-link d-flex flex-column align-items-center ">
                            <div className="page-details"
                                 onClick={() => navigate("/")}>
                                صفحه اصلی
                            </div>
                            <div className="page-details"
                                 onClick={() => navigate("/contact-us")}>
                                تماس با ما
                            </div>
                            <div className="page-details"
                                 onClick={() => navigate("/articles")}>
                                مقالات
                            </div>
                            <div className="page-details"
                                 onClick={() => navigate("/about-us")}>
                                درباره ما
                            </div>
                        </div>
                    </Col>
                    <Col sm={12} md={6} lg={2} className='product-footer pl-0 pl-md-4 pl-lg-4'>
                        <h3>خدمات ما</h3>
                        <div className="pages-link">
                            {
                                service.length > 0 ? service.map((item) => {
                                    return <div className="page-details"
                                                onClick={() => history.push(`/services/${item.slug}`)}>
                                        {item.title}
                                    </div>
                                }) : null
                            }
                        </div>
                    </Col>
                    <Col sm={12} md={6} lg={2} className='address-footer'>
                        <h3 className='text-center'>
                            تماس با ما
                        </h3>
                        <div className="d-flex justify-content-center align-items-center flex-column address">
                            <div className="page-details">
                                <div className='mt-0 mt-md-2'>
                                    <h5>
                                        تلفن :
                                    </h5>
                                    <p className='mt-1'>
                                        <a href={`tel:${DETAILS.phones[0]} `} className='text-white '>
                                            <strong>Reception : </strong>
                                            {
                                                DETAILS.phones[0]
                                            }
                                        </a>
                                    </p>
                                    <p className='mt-1'>
                                        <a href={`tel:${DETAILS.phones[1]} `} className='text-white'>
                                            <strong>Ceo founder : </strong>
                                            {
                                                DETAILS.phones[1]
                                            }
                                        </a>
                                    </p>
                                    <p className='mt-1'>
                                        <a href={`tel:${DETAILS.phones[2]} `} className='text-white'>
                                            <strong>Technical manager : </strong>
                                            {
                                                DETAILS.phones[2]
                                            }
                                        </a>
                                    </p>
                                    <p className='mt-1'>

                                        <a href={`tel:${DETAILS.phones[3]} `} className='text-white'>
                                            <strong>Interal manager : </strong>
                                            {
                                                DETAILS.phones[3]
                                            }
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col sm={12} md={6} lg={2} className='e-nemad '>
                        <div
                            className='d-flex  flex-column align-items-center justify-content-center mt-2 mt-md-3  m-auto'>
                            <div className="d-flex align-items-center justify-content-center">
                                <a referrerPolicy='origin' target='_blank'
                                   className='w-50'
                                   href='https://trustseal.enamad.ir/u?id=394595&code=cvmNRdZ1V1U7OaEZTfsv0wX1ZfHmX9BA'><img
                                    className=' d-flex  justify-content-center nemad '
                                    referrerPolicy='origin'
                                    src=''
                                    alt='' style={{cursor: 'pointer'}} code='cvmNRdZ1V1U7OaEZTfsv0wX1ZfHmX9BA'/></a>
                            </div>
                            <div className='w-100 d-flex align-items-center justify-content-center m-auto'>
                                <img src={logo} className='w-50 d-flx align-items-center justify-content-center'/>
                            </div>
                        </div>
                    </Col>
                </Row>
                <div className="copyright container-custom ">
                    <span>
                        کلیه حق و حقوق وبسایت برای <a href='https://farivarhesab.com/'
                                                      className='text-bold'> فریور حساب </a>  محفوظ است.
                    </span>
                    <div>
                        <span>
                             {'© ' + new Date().getFullYear() + ' - این وبسایت توسط '}
                            <span>
                        <a href="https://barantm.com" className='text-bold '>
                            شرکت برنامه نویسی باران
                        </a>
                    </span>
                            {' طراحی و تولید شده است.'}
                    </span>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Footer;